import { loadNs } from 'aa_common/front-end/i18n-config'

const t = loadNs(['pages/settings/roles'], 'permissions')
export const getChoices = () => [t('no_authority'), t('read'), t('cru'), t('crud'), t('execute')]
